import { useSearchParams } from 'react-router-dom'

export const ALL_PORTFOLIOS = 'all_portfolios'

export function useSelectedPortfolio() {
    const [searchParams, setSearchParams] = useSearchParams()
    const selectedPortfolioID = searchParams.get('selectedPortfolio')

    const setSelectedPortfolioID = (uuid: string | 'all_portfolios') => {
        setSearchParams(uuid !== 'all_portfolios' ? { selectedPortfolio: uuid } : {})
    }
    return {
        selectedPortfolioID: selectedPortfolioID || ALL_PORTFOLIOS,
        setSelectedPortfolioID,
    }
}

export default {
    useSelectedPortfolio,
}
